import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		minWidth: '400px',
		maxWidth: '500px',
	},
	header: {
		fontSize: '20px',
		marginBottom: '16px',
		color: '#333',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		marginBottom: '24px',
	},
	label: {
		fontSize: '14px',
		color: '#555',
		marginBottom: '8px',
	},
	dropdown: {
		width: '100%',
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '12px',
	},
	button: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '4px',
		fontSize: '14px',
		cursor: 'pointer',
		transition: 'background-color 0.2s',
	},
	cancelButton: {
		backgroundColor: '#f5f5f5',
		color: '#666',
		':hover': {
			backgroundColor: '#e0e0e0',
		},
	},
	notice: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	searchEmployeeBox: {
		fontSize: 14,
		marginTop: 16,
	},
	sendButton: {
		backgroundColor: '#007bff',
		color: 'white',
		':hover': {
			backgroundColor: '#0056b3',
		},
		':disabled': {
			backgroundColor: '#ccc',
			cursor: 'not-allowed',
		},
	},
	loadingText: {
		fontSize: '14px',
		color: '#666',
		fontStyle: 'italic',
	},
	errorText: {
		fontSize: '14px',
		color: '#d32f2f',
		marginTop: '8px',
	},
});
